<template lang="pug">
b-container.mt-5.pb-5
  b-row.align-items-center.justify-content-between
    b-col.align-self-stretch.align-items-center.justify-content-center.d-flex.img-size(cols="12" lg="6")
      //- img(width="100%" src="../../assets/imagesnew/about-image-min.jpg")
    b-col.message(cols="12" lg="6")
      .title.mb-5 Contact Us
      .text.mb-1
        strong mktBI
      .text.mb-1 Level 13, Broadgate Tower
      .text.mb-1 20 Primrose Street
      .text.mb-1 London
      .text.mb-1 EC2A 2EW
      .text.mb-4 United Kingdom

      .text.mb-4
        strong Email: 
        | info@mktbi.com

      .text
        strong Tel: 
        | +442071540884

</template>

<script>

export default {
  name: 'Contact',
  computed: {
    iconSrc () {
      return require(`@/assets/imagesnew/${this.icon}`)
    }
  },
  props: {
    title: {
      type: String,
      default: 'Focus on leveraging data available online'
    },
    icon: {
      type: String,
      default: 'online-data.jpg'
    }
  }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color-title: #364149;
$color-subtitle: #767F86;
.img-size {
  min-height: 300px;
  background: url("../../assets/imagesnew/maps.png");
  background-position: center;
  background-size: cover;
}
.message {
  color: $color-title;
  font-style: normal;
  font-weight: bold;
  border-top: #36C2CF solid 2px;
  padding: 51px 38px 51px 51px;
  background-color: #F7F8FC;
  .title {
    font-size: 40px;
    line-height: 1.2em;
  }
  .text {
    font-size: 16px;
    color: $color-subtitle;
    font-style: normal;
    font-weight: normal;
    line-height: 1.33em;
  }
}
.action {
  padding: 20px 29px 17px 29px;
  margin: 47px 0;
  background: #5473E8;
  border: none;
  border-radius: 100px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  display: flex;
  align-items: flex-end;
  text-align: center;
  text-transform: uppercase;
  color: #FFFFFF;
}
</style>
